$ = require 'jquery'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
BoardSelectOrganizationForPermChangeView = require 'views/board-menu/board-select-organization-for-perm-change-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
boardMenuVisTemplate = require 'views/templates/board_menu_vis'

module.exports = class ChangeBoardVisibilityView extends View
  viewTitleKey: ->
    if @model.owned()
      'change visibility'
    else
      'visibility'

  tagName: 'ul'

  initialize: ->
    @listenTo(@model, 'change', @render)
    return

  className: 'pop-over-list'

  maxWidth: 370

  events:
    'click .js-select': 'selectVis'

  render: ->
    org = @model.getOrganization()

    @$el.html boardMenuVisTemplate
      canChange: @model.owned()
      current: @model.getPref('permissionLevel')
      hasSuperAdmins: org?.isFeatureEnabled('superAdmins')
      hasOrg: org?
      orgName: org?.get('displayName')
      privateRestricted: org? && !org?.canSetVisibility('private')
      orgRestricted: org? && !org?.canSetVisibility('org')
      publicRestricted: org? && !org?.canSetVisibility('public')

    @

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')

    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    setting = $target.attr('name')

    if setting == 'org' && !@model.getOrganization()
      # show org picker
      PopOver.pushView
        view: BoardSelectOrganizationForPermChangeView
        options:
          model: @model
          modelCache: @modelCache
          disableNone: true
      return

    @model.setPref('permissionLevel', setting)
    @model.save()

    track("Board", "Change Board Visibility", setting)

    PopOver.popView()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-visibility-view.coffee